import { CardElement } from "@stripe/react-stripe-js";
import { Button, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Constants } from "../../../../utils";
import { useState } from "react";
import { Flex } from "antd";

const ModifyCard = ({
  showInvoiceNote = true,
  onCancel,
  onDone = async () => {},
}) => {
  const [valid, setValid] = useState(false);

  return (
    <div>
      <CardElement
        onChange={(_) => setValid(_.complete)}
        options={{ disableLink: true, hidePostalCode: true }}
      />
      {showInvoiceNote && (
        <Text
          className="m-30-t"
          type="secondary"
          children={Localization.formatString(
            Localization.service.payment_add_card_desc,
            <Text
              underline
              weight={600}
              level={"link"}
              className="m-30-t"
              children={Constants.Project.emails.support}
            />
          )}
        />
      )}
      <Flex gap={"1rem"} className="m-30-t">
        <Button
          type="primary"
          disabled={!valid}
          onClick={onDone}
          title={Localization.general.confirm}
        />
        {!!onCancel && (
          <Button onClick={onCancel} title={Localization.general.cancel} />
        )}
      </Flex>
    </div>
  );
};

export default ModifyCard;
